function resolveCdnEnv(raw) {
    if (raw === 'production' || raw === 'staging')
        return raw;
    return 'development';
}

export { resolveCdnEnv };
//# sourceMappingURL=resolveCdnEnv.js.map
